var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.002,
    height: 18.002
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.252v3.75h3.75l11.06-11.06-3.75-3.75zm17.71-10.21a1 1 0 000-1.41L15.37.292a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC4wMDIiIGhlaWdodD0iMTguMDAyIiB2aWV3Qm94PSIwIDAgMTguMDAyIDE4LjAwMiI+PHBhdGggZD0iTTMsMTcuMjVWMjFINi43NUwxNy44MSw5Ljk0LDE0LjA2LDYuMTlaTTIwLjcxLDcuMDRhMSwxLDAsMCwwLDAtMS40MUwxOC4zNywzLjI5YTEsMSwwLDAsMC0xLjQxLDBMMTUuMTMsNS4xMmwzLjc1LDMuNzUsMS44My0xLjgzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTIuOTk4KSIvPjwvc3ZnPg==";
export { SvgPencil as ReactComponent };